"use client";
import ScrollTriggeredSwiperSection, {
  ScrollTriggeredSwiperSectionProps,
} from "@cc/scrollTriggeredSwiperSection";
import { H6_2 } from "@theme/components/typography.fontvariant";

export type HamaaraSapnaStoriesProps = {
  data: ScrollTriggeredSwiperSectionProps["data"];
  navId?: string;
};

const HamaaraSapnaStories = (props: HamaaraSapnaStoriesProps) => {
  const { data, navId } = props;
  return (
    <ScrollTriggeredSwiperSection
      data={data}
      navId={navId || "stories"}
      EnhancedSwiperProps={{
        SlideComponentProps: {
          // InfoContainerProps: {
          //   sx: {
          //     height: {
          //       xs: "100%",
          //       md: 361,
          //     },
          //   },
          // },
          DescriptionTypographyProps: {
            fontSize: H6_2,
            sx: {
              opacity: 1,
              textAlign:'justify'
            },
          },
        },
      }}
    />
  );
};

export default HamaaraSapnaStories;
